var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _EventSender_instances, _EventSender_config, _EventSender_timers, _EventSender_init, _EventSender_setConfigToLocalStorage, _EventSender_validateConfig, _EventSender_setEventDone, _EventSender_formatEvents, _EventSender_getEvent, _EventSender_validateLinearEvent, _EventSender_log, _EventSender_sendNow, _EventSender_processTimeEvent, _EventSender_sendEvent;
import { AnalyticsManager } from '@libs/analytics/AnalyticsManager';
import { getLocalValue, setLocalValue, removeLocalValue, } from '@libs/utils/local-storage';
import { generateCustomUUID } from '@libs/utils/id';
const DEFAULT_CONFIG = {
    linear: false,
    log: false,
    done: false,
};
const EVENT_TEMPLATE = {
    name: '',
    done: false,
    once: false,
    type: 'default',
};
const MESSAGES = {
    category: `[EventSender] Initialization failed: 'category' property is required.`,
    events: `[EventSender] Initialization failed: 'events' array is required when 'linear' mode is enabled.`,
    localStorage: `[EventSender] Failed to read configuration from localStorage.`,
    event_not_found: `[EventSender] Cannot send event: event not found in configuration.`,
    event_once_done: `[EventSender] Cannot send event: this 'once' event has already been sent.`,
    event_linear_false: `[EventSender] Cannot send event: previous events in sequence have not been sent yet.`,
    event_sent: `[EventSender] Event sent successfully.`,
    event_name_error: `[EventSender] checkEventDone failed: event name not found.`,
    events_check_done_error: `[EventSender] checkEventsDone failed: type must be 'all' or 'any'.`,
    init_failed: '[EventSender] Initialization failed:',
    send_failed: '[EventSender] Failed to send analytics event:',
};
export class EventSender {
    constructor(customConfig) {
        _EventSender_instances.add(this);
        _EventSender_config.set(this, null);
        _EventSender_timers.set(this, {});
        __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_init).call(this, customConfig);
    }
    send(eventName, additionalData = {}) {
        __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_sendNow).call(this, eventName, additionalData);
    }
    startTimer(eventName) {
        __classPrivateFieldGet(this, _EventSender_timers, "f")[eventName] = { from: Date.now() };
    }
    checkDone() {
        var _a, _b;
        return (_b = (_a = __classPrivateFieldGet(this, _EventSender_config, "f")) === null || _a === void 0 ? void 0 : _a.done) !== null && _b !== void 0 ? _b : false;
    }
    setDone() {
        if (__classPrivateFieldGet(this, _EventSender_config, "f")) {
            __classPrivateFieldGet(this, _EventSender_config, "f").done = true;
            __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_setConfigToLocalStorage).call(this, __classPrivateFieldGet(this, _EventSender_config, "f"));
        }
    }
    checkEventDone(name) {
        const event = __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_getEvent).call(this, name);
        if (!event)
            throw new Error(`${MESSAGES.event_name_error} Event name - ${name}`);
        return event.done;
    }
    checkEventsDone(type = 'any') {
        var _a;
        if (!((_a = __classPrivateFieldGet(this, _EventSender_config, "f")) === null || _a === void 0 ? void 0 : _a.events))
            return false;
        if (type === 'all')
            return __classPrivateFieldGet(this, _EventSender_config, "f").events.every(event => event.done);
        if (type === 'any')
            return __classPrivateFieldGet(this, _EventSender_config, "f").events.some(event => event.done);
        throw new Error(`${MESSAGES.events_check_done_error} Event type - ${type}`);
    }
    static addGlobalProperty(key, value) {
        return AnalyticsManager.getInstance().addGlobalProperties({ [key]: value });
    }
    static addGlobalProperties(properties = {}) {
        return AnalyticsManager.getInstance().addGlobalProperties(properties);
    }
}
_EventSender_config = new WeakMap(), _EventSender_timers = new WeakMap(), _EventSender_instances = new WeakSet(), _EventSender_init = function _EventSender_init(customConfig) {
    var _a, _b, _c;
    try {
        const manager = AnalyticsManager.getInstance();
        const userChanged = manager.checkUserChanged();
        if (userChanged)
            removeLocalValue(`${customConfig.category}-event`);
        const storedConfig = getLocalValue(`${customConfig.category}-event`);
        if (!storedConfig || !__classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_validateConfig).call(this, storedConfig)) {
            const normalizedEvents = __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_formatEvents).call(this, customConfig.events);
            const newConfig = Object.assign(Object.assign({}, DEFAULT_CONFIG), { category: customConfig.category, linear: (_a = customConfig.linear) !== null && _a !== void 0 ? _a : DEFAULT_CONFIG.linear, log: (_b = customConfig.log) !== null && _b !== void 0 ? _b : DEFAULT_CONFIG.log, done: (_c = customConfig.done) !== null && _c !== void 0 ? _c : DEFAULT_CONFIG.done, events: normalizedEvents });
            if (!__classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_validateConfig).call(this, newConfig))
                return;
            __classPrivateFieldSet(this, _EventSender_config, newConfig, "f");
            __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_setConfigToLocalStorage).call(this, __classPrivateFieldGet(this, _EventSender_config, "f"));
        }
        else {
            __classPrivateFieldSet(this, _EventSender_config, storedConfig, "f");
        }
    }
    catch (error) {
        console.error(MESSAGES.init_failed, error);
    }
}, _EventSender_setConfigToLocalStorage = function _EventSender_setConfigToLocalStorage(config) {
    setLocalValue(`${config.category}-event`, config);
}, _EventSender_validateConfig = function _EventSender_validateConfig(config) {
    var _a;
    try {
        if (!(config === null || config === void 0 ? void 0 : config.category)) {
            throw new Error(MESSAGES.category);
        }
        if ((config === null || config === void 0 ? void 0 : config.linear) && !((_a = config === null || config === void 0 ? void 0 : config.events) === null || _a === void 0 ? void 0 : _a.length)) {
            throw new Error(MESSAGES.events);
        }
    }
    catch (error) {
        if (error instanceof Error)
            __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_log).call(this, error.message);
        return false;
    }
    return true;
}, _EventSender_setEventDone = function _EventSender_setEventDone(eventName) {
    const event = __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_getEvent).call(this, eventName);
    if (event)
        event.done = true;
}, _EventSender_formatEvents = function _EventSender_formatEvents(events = []) {
    return events.map(event => {
        const eventObj = typeof event === 'string' ? { name: event } : event;
        return Object.assign(Object.assign({}, EVENT_TEMPLATE), eventObj);
    });
}, _EventSender_getEvent = function _EventSender_getEvent(eventName) {
    var _a;
    return (_a = __classPrivateFieldGet(this, _EventSender_config, "f")) === null || _a === void 0 ? void 0 : _a.events.find(event => event.name === eventName);
}, _EventSender_validateLinearEvent = function _EventSender_validateLinearEvent(event) {
    if (!__classPrivateFieldGet(this, _EventSender_config, "f"))
        return false;
    const events = __classPrivateFieldGet(this, _EventSender_config, "f").events;
    const eventIndex = events.indexOf(event);
    const prevEvents = events.slice(0, eventIndex);
    return prevEvents.every(e => e.done);
}, _EventSender_log = function _EventSender_log(message) {
    var _a;
    if ((_a = __classPrivateFieldGet(this, _EventSender_config, "f")) === null || _a === void 0 ? void 0 : _a.log)
        console.warn(message);
}, _EventSender_sendNow = function _EventSender_sendNow(eventName, additionalData = {}) {
    var _a;
    if (!__classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_validateConfig).call(this, __classPrivateFieldGet(this, _EventSender_config, "f")))
        return;
    const eventFromConfig = __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_getEvent).call(this, eventName);
    if (!eventFromConfig) {
        __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_log).call(this, `${MESSAGES.event_not_found} Event name - '${eventName}'`);
        return;
    }
    if (eventFromConfig.once && eventFromConfig.done) {
        const msg = `${MESSAGES.event_once_done} Event name - '${eventFromConfig.name}'`;
        __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_log).call(this, msg);
        return;
    }
    if (((_a = __classPrivateFieldGet(this, _EventSender_config, "f")) === null || _a === void 0 ? void 0 : _a.linear) && !__classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_validateLinearEvent).call(this, eventFromConfig)) {
        const msg = `${MESSAGES.event_linear_false} Event name - '${eventFromConfig.name}'`;
        __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_log).call(this, msg);
        return;
    }
    const dataToSend = eventFromConfig.type === 'time'
        ? __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_processTimeEvent).call(this, eventName, additionalData)
        : additionalData;
    __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_sendEvent).call(this, eventFromConfig.name, dataToSend);
    __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_log).call(this, `${MESSAGES.event_sent} Event - '${eventFromConfig.name}'`);
    __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_setEventDone).call(this, eventFromConfig.name);
    __classPrivateFieldGet(this, _EventSender_instances, "m", _EventSender_setConfigToLocalStorage).call(this, __classPrivateFieldGet(this, _EventSender_config, "f"));
}, _EventSender_processTimeEvent = function _EventSender_processTimeEvent(eventName, additionalData) {
    const timer = __classPrivateFieldGet(this, _EventSender_timers, "f")[eventName];
    if (!(timer === null || timer === void 0 ? void 0 : timer.from))
        return additionalData;
    const activeSeconds = Math.floor((Date.now() - timer.from) / 1000);
    delete __classPrivateFieldGet(this, _EventSender_timers, "f")[eventName];
    return Object.assign(Object.assign({}, additionalData), { interaction_time_in_sec: activeSeconds });
}, _EventSender_sendEvent = function _EventSender_sendEvent(action, additionalData = {}) {
    const dataToSend = Object.assign({}, additionalData);
    if (!dataToSend.event_id)
        dataToSend.event_id = generateCustomUUID();
    const manager = AnalyticsManager.getInstance();
    const success = manager.sendEvent(action, dataToSend);
    if (!success)
        console.error(MESSAGES.send_failed, action);
};
